import type React from 'react';
import { type FC, useState } from 'react';

import { Icon } from '@iconik-io/uad';

import Button from '../../ui/button/button';
import IconButton from '../../ui/icon_button/icon_button';

import styles from './search_input_panels.module.css';

type Props = {
  searchText: string;
  showNewButton: boolean;
  isNewButtonDisabled: boolean;
  onTextInput: (value: string) => void;
  onNewButtonClick: () => void;
};

const SearchInputPanels: FC<Props> = ({
  searchText,
  showNewButton,
  isNewButtonDisabled,
  onTextInput,
  onNewButtonClick,
}) => {
  const [value, setValue] = useState(searchText);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    onTextInput(event.target.value);
    setValue(event.target.value);
  };

  const handleClear = (): void => {
    setValue('');
    onTextInput('');
  };

  return (
    <div className={styles.root}>
      <div className={styles.input_wrapper}>
        <div className={styles.search_icon}>
          <Icon name="search" />
        </div>
        <input
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          className={styles.input}
          name="query"
          inputMode="search"
          value={value}
          placeholder="Search…"
          onChange={handleChange}
          aria-label="Panels search input"
          role="searchbox"
        />
        {value.length !== 0 && (
          <div className={styles.clear_button}>
            <IconButton
              iconName="deletion_clear"
              iconSizeUAD="s"
              name="Clear"
              role="button"
              onClick={handleClear}
            />
          </div>
        )}
      </div>
      {showNewButton ? (
        <Button
          className={styles.new_button}
          variant="success"
          noBorder
          disabled={isNewButtonDisabled}
          iconName="plus"
          onClick={onNewButtonClick}
        >
          New
        </Button>
      ) : null}
    </div>
  );
};

export default SearchInputPanels;
